import React, {useContext} from "react";
import HelpComponent from "components/HelpComponent";
import TextInput from "components/TextInput";
import FormTranslationContext from "context/FormTranslationContext";
import INPUT_TYPE from "../../../../../constants/INPUT_TYPE";

function NoticeIntegerInput
({
     id,
     label,
     formikProps,
     disabled,
     required
 }) {
    const {formTr, formTip} = useContext(FormTranslationContext)
    const tip = formTip(label ? label : id);


    const input = <TextInput
        id={id}
        type={INPUT_TYPE.INTEGER_POSITIVE_AMOUNT}
        label={formTr(label ? label : id)}
        formikProps={formikProps}
        required={required}
        disabled={disabled}
        skipCheckTouched
    />

    if (tip)
        return <HelpComponent text={tip}>
            {input}
        </HelpComponent>
    return input;


}

export default NoticeIntegerInput;